import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { stopPropagation } from '../../../../../utils/events'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  getIsListingActionRestore,
  LISTING_ACTION_RESTORE,
} from '../../../../RentalPortalListing'
import {
  getIsRentalPortalArchiveRestoreAllowed,
  getRentalPortalArchiveRestoreDescription,
} from '../../RentalPortalArchive.utils'

import RestoreIcon from '../../../../../icons/restore.svg'

export function useRentalPortalArchiveRowActions({
  setModal,
  onClose,
  onPerformAction,
}) {
  const { t } = useTranslation()

  function getHandleSubmitRestore(item) {
    return async event => {
      stopPropagation(event)

      return onPerformAction({ action: LISTING_ACTION_RESTORE, ids: [item.id] })
    }
  }

  function setItemAction(item) {
    if (!getIsRentalPortalArchiveRestoreAllowed(item)) {
      return null
    }

    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: RestoreIcon } },
          submitText: t('RentalPortal.ListingRestoreBtnKey'),
        }}
        description={getRentalPortalArchiveRestoreDescription({ item, t })}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={onClose}
        onSubmit={getHandleSubmitRestore(item)}
      />
    )
  }

  function handleCallItemAction(action, item) {
    return getIsListingActionRestore(action) ? setItemAction(item) : null
  }

  return { handleCallItemAction }
}
